import { SiteActivityEvent, generator } from '@cms-max/cms-browser-api-client'
import { Activity, Component } from '@cms-max/medicare-api-sdk'
import { GeneratorArgs } from './generateEventMap'

export const downloadMyDataEventGenerator = generator(({ i18n }: GeneratorArgs) => {
  const createDownloadMyDataLinkClickHandler = (elementId: string) => (
    params: {
    linkText?: string,
    linkUrl?: string
  }): SiteActivityEvent => ({
    core: {
      elementId,
      property: 'MAX',
      activity: Activity.LinkClick,
      component: Component.DownloadMyData,
      coreClickData: {
        linkText: params.linkText,
        linkUrl: params.linkUrl
      }
    }
  })

  return {
    downloadmydata_interimpage__claims_click: createDownloadMyDataLinkClickHandler(
      'downloadmydata_interimpage__claims_click'
    ),
    downloadmydata_interimpage__plans_click: createDownloadMyDataLinkClickHandler(
      'downloadmydata_interimpage__plans_click'
    ),
    downloadmydata_interimpage_ps_click: createDownloadMyDataLinkClickHandler(
      'downloadmydata_interimpage_ps_click'
    )
  }
})

export type DownloadMyDataKeys = keyof ReturnType<typeof downloadMyDataEventGenerator>

export default downloadMyDataEventGenerator
